import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) return setState("error");
    let tries = 0, timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setState("paid");
        if (data.status === "expired" || data.payment_status === "failed") return setState("error");
      } catch { return setState("error"); }
      if (++tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);

  const text = { checking: "Confirming payment...", paid: "CHAPTER UNLOCKED", error: "Payment could not be confirmed.", timeout: "Still processing. Check back shortly." }[state];

  return (
    <div className="screen-center px-6" data-testid="payment-success-page">
      <div className="text-left max-w-xl rise">
        <h1 className={`font-display text-4xl sm:text-5xl lg:text-6xl font-black ${state === "paid" ? "text-[#DC2626] flicker" : "text-[#F3F4F6]"}`} data-testid="payment-status-text">{text}</h1>
        {state === "checking" && <p className="pixel-text text-2xl text-[#9CA3AF] mt-4 blink">_</p>}
        {state === "paid" && <p className="pixel-text text-2xl text-[#9CA3AF] mt-4">The door creaks open. There's no turning back now.</p>}
        <button className="pixel-btn mt-10" onClick={() => nav("/")} data-testid="payment-return-button">Return to chapters</button>
      </div>
    </div>
  );
}
